import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ContentWrapper, Panel, EmptyStateWrapper } from '@checkmarx/cx-ui';
import LdapServers from './ldapServers';
import ScreenLoaderContainer from '../portal/controls/screenLoaderContainer';
import LdapEditFormsContainer from './ldapEditFormsContainer';
import { LdapEditMode } from '../../services/enums/ldap';

@inject('translationsStore', 'rootLdapStore', 'routesStore') @observer
export default class LdapSettingsContainer extends Component {

    state = {
        add: false
    };

    componentDidMount() {

        this.props.routesStore.setSettingsSelectedTabId(this.props.tabId);
        this.props.rootLdapStore.getLDAPServers();
    }

    openAddServerForm = () => {

        this.setState({
            add: true
        });
    }

    cancelAdd = () => {

        this.props.rootLdapStore.ldapStore.resetForm();
        this.props.rootLdapStore.ldapValidator.resetForm();
        
        this.setState({
            add: false
        });
    }

    render(){

        let content = <ScreenLoaderContainer />
        let title = null;

        if (this.props.rootLdapStore.ldapServers == undefined) {
            
            return <ContentWrapper className='content-wrapper' />
        }

        if(this.props.rootLdapStore.ldapServers.length == 0) {

            content = this.state.add ? <div className='ldap-add-form-wrapper'>
                        <LdapEditFormsContainer mode={LdapEditMode.add} cancelAddEdit={this.cancelAdd} />
                      </div>
                      : <EmptyStateWrapper 
                            onClick={this.openAddServerForm}
                            text={this.props.translationsStore.translate('ADD_NEW_LDAP_SERVER')} />;
        }
        else {

            title = this.props.translationsStore.translate('LDAP_SERVERS');
            content = <LdapServers ldapServers={this.props.rootLdapStore.ldapServers} />;
        }

        return(
            <ContentWrapper className='content-wrapper'>
                <Panel className='content-left-hand'>
                    <div className='setting-title'>
                        {this.props.translationsStore.translate('LDAP_SETTINGS_TITLE')}
                    </div>
                    <div className='setting-sub-title'>
                        {this.props.translationsStore.translate('LDAP_SETTINGS_SUB_TITLE')}
                    </div>
                </Panel>
                <Panel className='content-right-hand'>
                    <div className='title'>
                        {title}
                    </div>
                    {content}
                </Panel>
            </ContentWrapper>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ldap/index.jsx